import { useAssets, useUser } from 'hooks';
import React, { useState } from 'react';

import { AssetStatuses } from 'hooks/useAssets/useAssets.types';
import { ProxyMetadata } from 'hooks/useAssets/useAssets.types';
import { Form } from 'form/form/Form';
import { useIam } from 'api/hooks/useIam/useIam';
import { IssueAssetForm } from 'app/issueAsset/IssueAsset.types';

import { IssueAsset } from './IssueAsset';

export const IssueAssetContainer = () => {
  const { updateToken, getOwnedTokens } = useIam();
  const { setAssetsFromClaims } = useAssets();
  const [isLoading, setLoading] = useState(false);
  const [isError, setError] = useState(false);
  const [id, setId] = useState('');
  const { user } = useUser();

  const onSubmit = async (values: IssueAssetForm) => {
    setError(false);
    setLoading(true);
    try {
      await updateToken({
        ...values,
        status: AssetStatuses.ISSUED,
        manufacturer: user && {
          name: user.name,
          address: user.address,
        },
        origin: user?.origin,
        dateOfIssue: new Date().toISOString(),
      });
      const tokens = await getOwnedTokens();
      setAssetsFromClaims(tokens as ProxyMetadata[]);
      setId(values.id as string);
      setLoading(false);
    } catch (e) {
      setError(true);
      setLoading(false);
    }
  };

  return (
    <Form shouldUnregister={false} mode="onBlur">
      {({ handleSubmit }) => (
        <IssueAsset isLoading={isLoading} id={id} onSubmit={handleSubmit(onSubmit)} isError={isError} />
      )}
    </Form>
  );
};
